import { ComponentRegistryService, type ComponentDef } from "#gen/pages/v2/component_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { Client } from "@connectrpc/connect";

export class RegistryClient {
	private client: Client<typeof ComponentRegistryService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.componentRegistry || "/", ComponentRegistryService, options);
	}

	async getAllComponents(): Promise<ComponentDef[]> {
		try {
			const res = await this.client.getComponents({});
			return res.definitions;
		} catch (e) {
			throw handleError(e);
		}
	}

	async getComponents(typeUris: string[]): Promise<ComponentDef[]> {
		try {
			const res = await this.client.getComponents({ typeUris });
			return res.definitions;
		} catch (e) {
			throw handleError(e);
		}
	}
}
